import { Environment } from './environment.model';
import { getEnvVar } from './get-env-var';

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * IMPORTANT:
 *
 * ALL ENV_VARS NEED TO BE APPLIED TO `env.{envName}.js`
 * OTHERWISE THEY WILL NOT BE INCLUDED.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
export const environment: Environment = {
  production_build: true,
  name: getEnvVar('APP_NAME'),
  release_version: getEnvVar('APP_VERSION'),
  full_story_org: getEnvVar('FULL_STORY_ORG'),
  url: {
    app: getEnvVar('APP_URL'),
    json_schema: getEnvVar('API_URL_JSON_SCHEMA'),
    trigger_api: getEnvVar('API_URL_TRIGGER'),
    trigger_api_new: getEnvVar('API_URL_TRIGGER_NEW'),
    credential: getEnvVar('API_URL_CREDENTIAL'),
    analytic_api: getEnvVar('API_URL_ANALYTICS'),
    modeling_api: getEnvVar('API_URL_MODELING'),
    identity_api: getEnvVar('API_URL_IDENTITY_MANAGER'),
    company_api: getEnvVar('API_URL_COMPANY'),
    acl_api: getEnvVar('API_URL_ACL'),
    spaces_api: getEnvVar('API_URL_SPACES'),
    view_manager_api: getEnvVar('API_URL_VIEW_MANAGER'),
    notification_api: getEnvVar('API_URL_UI_NOTIFICATIONS'),
    ws_events_api: getEnvVar('API_URL_WS_EVENTS'),
    segment_api: getEnvVar('API_URL_SEGMENT'),
    frontend_storage_api: getEnvVar('API_URL_FRONTEND_STORAGE'),
    lineage_api: getEnvVar('API_URL_LINEAGE_SERVICE'),
    chat_api: getEnvVar('API_URL_CHAT'),
    orchestration_api: getEnvVar('API_URL_ORCHESTRATION'),
    ux3_orchestration_api: getEnvVar('API_URL_ORCHESTRATION_UX3'),
    job_info_api: getEnvVar('API_URL_JOB_INFO'),
    auto_billing_api: getEnvVar('API_URL_AUTO_BILLING'),
    data_test_api: getEnvVar('API_URL_DATA_TESTS'),
    dbt_api: getEnvVar('API_URL_DBT'),
  },
  gitlab: {
    url: getEnvVar('GITLAB_URL'),
  },
  auth: {
    issuer: getEnvVar('API_URL_HYDRA'),
    clientId: getEnvVar('OAUTH_CLIENT_ID'),
  },
  pusher: {
    key: getEnvVar('PUSHER_KEY'),
    cluster: getEnvVar('PUSHER_CLUSTER'),
  },
  sentry: {
    dsn: getEnvVar('SENTRY_DSN'),
    sentry_org: getEnvVar('SENTRY_ORG'),
  },
  gojs: {
    key: getEnvVar('GO_JS_KEY'),
  },
  contentful: {
    datosStoreSpace: {
      space: getEnvVar('CONTENTFUL_SPACE'),
      environment: getEnvVar('CONTENTFUL_ENV'),
      accessToken: getEnvVar('CONTENTFUL_TOKEN'),
      host: getEnvVar('CONTENTFUL_HOST'),
    },
  },
  zendesk: {
    article: {
      enable: getEnvVar('ZENDESK_ENABLED'),
      endpoint: getEnvVar('ZENDESK_ENDPOINT'),
    },
    support: {
      api_url: getEnvVar('ZENDESK_SUPPORT_API_URL'),
    },
  },
  infra_status: {
    api_url: getEnvVar('INFRA_STATUS_API_URL'),
  },
  rudderstack: {
    writeKey: getEnvVar('RUDDERSTACK_WRITE_KEY'),
  },
};
